<a class="support-documentation__category-card" [routerLink]="['/support-documentation/category', category.slug]">
  <sbnb-support-documentation-icon [icon]="category.icon"></sbnb-support-documentation-icon>
  <div>{{ category.name }}</div>
</a>
